import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var config = {
  apiKey: 'AIzaSyDca8hPLeseAr7SPqMIWfv1ocWOqoLiMMw',
  authDomain: 'tc-training.firebaseapp.com',
  databaseURL: 'https://tc-training.firebaseio.com',
  projectId: 'tc-training',
  storageBucket: 'tc-training.appspot.com',
  messagingSenderId: '1082122132942',
  appId: '1:1082122132942:web:5d42c48d831318c3019f9f',
  measurementId: 'G-V3XC94X7XW'
}

const firebaseApp = firebase.initializeApp(config)

export default firebaseApp
